import {
  CaretDownOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Dropdown, message, Modal,
  Row,
  Space,
  Switch,
  Table, Tooltip, Tag
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SET_JOB_SCHEDULE } from "../../../common/actionTypes";
import {
  CronExpression, CRON_JOB_NAME, JOB_STATUS, CONSTANTS
} from "../../../common/constants/constants";
import { service } from "../../../services";
import "./viewlogs.scss";
let list_of_EU_ID = [];

const JobDetails = ({
  viewLogsOpen,
  handleCloseViewLogs,
  cronJobName,
  cronJobType,
  name,
  expression
}) => {

  const dispatch = useDispatch();
  const dataFetchedRef = useRef(false);
  const jobschedule = useSelector((state) => state?.auth?.jobschedule);
  const [dropdown, setDropdown] = useState(jobschedule?.label);
  const [jobstatus, setJobStatus] = useState(jobschedule?.jobstatus);
  const [loader, setLoader] = useState(false);
 const [logsList, setLogsList] = useState([]);
  const [showbutton, setShowbutton] = useState(null);
  const [updatemodalopen, setUpdateModalOpen] = useState(false);
  const [cronJobDetails, setCronJobDetails] = useState();
  const [loading, setLoading] = useState(false);
  const [dataListExpand, setDataListExpand] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    size: 10,
    total: 0,
  });
  const [customScopeTableData, setCustomScopeTableData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState();

  const updateExpandedRowKeys = (record) => {
    const rowKey = record.key;
    const isExpanded = expandedRowKeys?.find((key) => key === rowKey);
    let newExpandedRowKeys = [];
    if (isExpanded) {
      newExpandedRowKeys = expandedRowKeys.reduce((acc, key) => {
        if (key !== rowKey) acc.push(key);
        return acc;
      }, []);
    } else {
      getDataListExpand(record.jobId);
      newExpandedRowKeys = expandedRowKeys;
      newExpandedRowKeys?.push(rowKey);
    }
    setExpandedRowKeys(newExpandedRowKeys);
  };

  useEffect(() => {
    if (dataFetchedRef.current) {
      dataFetchedRef.current = false;
      return;
    } else {
      dataFetchedRef.current = true;
      getLogDetails({
        page: 1,
        size: 10,
        all: false,
        datatype: expression ? expression : jobschedule.key,
      });
    }
  }, [viewLogsOpen, handleCloseViewLogs, cronJobName, cronJobType, name]);

  useEffect(()=>{
    return ()=>{list_of_EU_ID = [];}
  }, [])

  const getLogDetails = async (value) => {
    setLogsList([]);
    setExpandedRowKeys([]);
    setCustomScopeTableData([]);
    setLoader(true);
    let jobType = cronJobType;
    let payload = {
      page: value?.page,
      size: value?.size,
      jobstatus: value.jobstatus,
      datatype: value.datatype,
    };
    await service.getLogDetailsList(payload, jobType).then((respo)=>{
      setLoader(false);
      if (respo.success) {
        setPagination({
          total: respo.data.totalCount,
          current: respo.data.page,
          size: 10,
        });
        respo.data.data?.map((item, index) => {
          item.key = index + 1;
          setLogsList((oldArray) => [...oldArray, item]);
          setCustomScopeTableData((oldArray) => [...oldArray, item]);
        });
      } else {
        console.log("error", respo.message);
      }
    });
  };

  const makeElipsis = (txt) => {
    if (!txt) return null;
    return txt.length > 20 ? `${txt.substring(0, 25)}...` : txt;
  };

  const handleupdatemodalopen = () => {
    setUpdateModalOpen(false);
  };

  const handleMenuClick = (e) => {
    CronExpression?.map((item) => {
      if (item?.key == e?.key) {
        setDropdown(item?.label);
        setShowbutton(item?.label);
        item.jobstatus = jobstatus;
        dispatch({
          type: SET_JOB_SCHEDULE,
          payload: item,
        });
      }
    });
  };

  const handleStatus = (value) => {
    setJobStatus(value);
    const payload = jobschedule;
    payload.jobstatus = value;
    dispatch({
      type: SET_JOB_SCHEDULE,
      payload: payload,
    });
  };

  useEffect(()=> {
      if(cronJobName){
        getCronJobDetails();
      }
  },[]);

  // get cron job details
  const getCronJobDetails = async () => {
    setLoader(true);
    // let jobName = CRO;
    let respo = await service.getCronJobDetails(cronJobName);
    if (respo?.success) {
      setLoader(false);
      setCronJobDetails(respo?.data);
      if (respo?.data?.isDeleted) {
        setJobStatus(false);
      } else {
        setJobStatus(true);
      }
      const expression = {
        label: respo?.data?.expressionDescription,
        key: respo?.data?.expression,
        status: respo?.data?.isDeleted,
      };
      setDropdown(respo?.data?.expressionDescription);
      dispatch({
        type: SET_JOB_SCHEDULE,
        payload: expression,
      });
    } else {
      setLoader(false);
      console.log("error", respo.message);
    }
  };

  // save and update cron job details
  const updateCronJobDetails = async (value) => {
    // let jobName = CRON_JOB_NAME.AP_PROHANCE_SYNC;
    let payload = {
      expression: value?.datatype,
      isDeleted: value.jobstatus,
      expressionDescription: value.expressionDescription,
    };
    let respo = await service.updateCronJobDetails(payload, cronJobName);
    if (respo?.success) {
      setCronJobDetails(respo?.data?.data);
      if (respo?.data?.data?.isDeleted) {
        setJobStatus(false);
      } else {
        setJobStatus(true);
      }
      const expression = {
        label: respo?.data?.data?.expressionDescription,
        key: respo?.data?.data?.expression,
        status: respo?.data?.data?.isDeleted,
      };
      setDropdown(respo?.data?.data?.expressionDescription);
      dispatch({
        type: SET_JOB_SCHEDULE,
        payload: expression,
      });
      handleupdatemodalopen();
      setShowbutton(null);
      message.success(respo?.data?.message);
    } else {
      console.log("error", respo.message);
    }
  };

  const columns = [
    {
      title: "",
      width: 10,
    },
    {
      title: "Job ID",
      render: (value, row) => (
        <>
          <Tooltip placement="bottom" title={row?.jobId}>
            <div>{row?.jobId}</div>
          </Tooltip>
        </>
      ),
      key: "jobId",
    },
    {
      title: "Started On",
      dataIndex: "createdAt",
      key: "createdAt",
    },
  ];

  const getDataListExpand = async (jobId) => {
    if (list_of_EU_ID.indexOf(jobId) == -1) {
      list_of_EU_ID.push(jobId);
      setLoading(true);
      const payload = {
        jobId: jobId,
      };
      service.getCronLogDetails(payload).then((res) => {
        res.data.map(item=>{
          setDataListExpand((oldArray) => [
            ...oldArray,
            item,
          ]);
        })
        setLoading(false)
      });
    }
  };
  const columnsExpand = [
    {
      title: "",
      width: 10,
    },
    {
      title: "Status",
      key: "status",
      width: "20%",
      render: (value, row) => (
        <>
          {row.status === JOB_STATUS.ERROR ? (
            <Tag color="red">{row.status}</Tag>
          ) : (
            <></>
          )}
          {row.status === JOB_STATUS.STARTED ? (
            <Tag color="blue">{row.status}</Tag>
          ) : (
            <></>
          )}
          {row.status === JOB_STATUS.INPROGRESS ? (
            <Tag color="green">{row.status}</Tag>
          ) : (
            <></>
          )}
          {row.status === JOB_STATUS.FINISHED ? (
            <Tag color="purple">{row.status}</Tag>
          ) : (
            <></>
          )}
        </>
      ),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      render: (value, row) => (
        <>
            <div>{row?.remark}</div>
        </>
      ),
      width: "40%",
      key:'remark'
    },
    {
      title: "Created At",
      render: (value, row) => (
        <>
            <div style={{fontWeight:'bold'}}>{row?.createdAt}</div>
        </>
      ),
      key: "createdAt",
      width: "20%",
    },
    {
      title: "Updated At",
      render: (value, row) => (
        <>
            <div>{row?.updatedAt}</div>
        </>
      ),
      width: "20%",
      key: "updatedAt",
    },
  ];

  return (
    <>
      <Modal
        style={{
          top: 14,
        }}
        width="80%"
        open={viewLogsOpen}
        onCancel={handleCloseViewLogs}
        closeIcon={
          <CloseCircleOutlined
            className="close-iconC"
            onClick={handleCloseViewLogs}
          />
        }
        footer={null}
        className="create-condition-modal"
      >
        <div className="modal-title">
          {`${name && name+' -'} Auto Provisioning Job Details`}
        </div>
        {(name == CONSTANTS.PROHANCE || !name) && 
          <div className="center">
            <div className="job-status">
              Job Status:
              <Switch
                style={{ marginLeft: "8px" }}
                size="small"
                checkedChildren="Active"
                unCheckedChildren="Inactive"
                onChange={() => {
                  setShowbutton(true);
                  handleStatus(jobstatus === true ? false : true);
                }}
                checked={jobstatus}
              />
            </div>
            <div className="job-she">
              <div className="select-job">Select Job Schedule :</div>
              <Dropdown
                placeholder="Select Data Type"
                className="drop1"
                trigger={["click"]}
                menu={{
                  items: CronExpression,
                  className: "me",
                  selectable: true,
                  onClick: handleMenuClick,
                  selectedKeys: jobschedule.key,
                }}
              >
                <Button className="dropB">
                  <Space className="job-select">{dropdown}</Space>
                  <Space>
                    <CaretDownOutlined className="caretIcon" />
                  </Space>
                </Button>
              </Dropdown>
            </div>
            {showbutton !== null ? (
              <button
                onClick={() => setUpdateModalOpen(true)}
                className="update-job-btn"
                size="small"
              >
                Update
              </button>
            ) : (
              <Button className="disable" disabled>
                Update
              </Button>
            )}
          </div>
        }
        <Divider className="log-divider">Job Logs</Divider>
        <div className="job-log-table-list">
          <div className="table-view6">
            <Row>
              <Col span={24}>
                <div className="ap-table-style viewt  mart">
                  <Table
                    columns={columns}
                    loading={loader}
                    expandable={{
                      expandedRowRender: (record) => (
                        <Table
                          className="ap-table-style8"
                          columns={columnsExpand}
                          loading={loading}
                          dataSource={dataListExpand.filter(
                            (row) => row.jobId === record.jobId
                          )}
                          pagination={false}
                          showPaginationBottom={false}
                        />
                      ),
                      expandedRowKeys: expandedRowKeys,
                      onExpand: (expanded, record) => {
                        updateExpandedRowKeys(record);
                      },
                    }}
                    dataSource={customScopeTableData}
                    pagination={{
                      ...pagination,
                      onChange: (page, pageSize) => {
                        getLogDetails({
                          page: page,
                          size: 10,
                          all: false,
                        });
                      },
                      showSizeChanger: false,
                    }}
                    size="small"
                    className="ant-pagination jobtable "
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <Modal
          className="modal-H"
          footer={null}
          closable={false}
          open={updatemodalopen}
        >
          <div className="div-center">
            <QuestionCircleOutlined className="div-icon" />
            <Space>
              <h4 style={{ fontWeight: "600" }}>
                Are you sure you want to update the job?
              </h4>
            </Space>
            <div className="modal-div">
              <Button
                style={{ marginRight: "10px" }}
                key="console"
                onClick={() => {
                  getCronJobDetails();
                  handleupdatemodalopen();
                  setShowbutton(null);
                }}
              >
                Cancel
              </Button>
              <Button
                className="create"
                type="primary"
                key="console"
                onClick={() => {
                  updateCronJobDetails({
                    datatype: jobschedule.key,
                    jobstatus: jobstatus === true ? false : true,
                    expressionDescription: jobschedule.label,
                  });
                  setShowbutton(null);
                  getLogDetails({
                    page: 1,
                    size: 10,
                    all: false,
                    datatype: jobschedule.key,
                    jobstatus: jobstatus,
                  });
                }}
              >
                OK
              </Button>
            </div>
          </div>
        </Modal>
      </Modal>
    </>
  );
};

export default JobDetails;
